import { Waypoint } from 'react-waypoint';

import { useTrackViewBlock } from '@/modules/analytic/hooks/useTrackViewBlock';
import { Block } from '@/types';
import { websiteOffersRoute } from '@/utils/routes';

import { BannerSubscription } from './BannerSubscription';
import { CarouselBlock, HeaderCarouselBlock, ProgressCarouselBlock } from './carouselsBlocks';

interface BlockProps {
  blocks: Block[];
}

export const Blocks = ({ blocks = [] }: BlockProps) => {
  const { trackViewBlock } = useTrackViewBlock();

  const renderBlock = (block: Block) => {
    switch (block.size) {
      case 'header':
        return <HeaderCarouselBlock block={block} />;
      case 'default':
        return <CarouselBlock block={block} />;
      case 'progress':
        return <ProgressCarouselBlock block={block} />;
      case 'ad':
        return (
          <BannerSubscription
            title="program.banner.title"
            description="program.banner.description"
            buttonLabel="program.banner.button.title"
            link={websiteOffersRoute}
          />
        );
    }
  };

  return blocks.map((block) => {
    return (
      <div key={block.UUID}>
        <Waypoint onEnter={() => trackViewBlock({ block })} />
        {renderBlock(block)}
      </div>
    );
  });
};
